import { render, staticRenderFns } from "./PlantATree.vue?vue&type=template&id=a6fecd68&scoped=true"
import script from "./PlantATree.vue?vue&type=script&lang=js"
export * from "./PlantATree.vue?vue&type=script&lang=js"
import style0 from "./PlantATree.vue?vue&type=style&index=0&id=a6fecd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fecd68",
  null
  
)

export default component.exports